import { TableCell, TableRow, Tooltip } from '@mui/material';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import styles from './DocumentItem.module.scss';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import getDocumentStatusByDocumentName from '../../../../../api/Purchasers/getDocumentStatus.api';
import * as DOCUMENT_NAME from '../../../../../constants/documentNames';
import { useHistory } from 'react-router';
import { connect } from 'react-redux';
import { closeModal, openModal } from '../../../../../redux/modals/action';
import viewDocument from '../../../../../api/Purchasers/viewDocuments.api';
import {
	getAuditTrail,
	setDocumentTarget,
	setLoading,
} from '../../../../../redux/purchasers/actions';

import * as ORIGINAL_HREF from '../../../../../constants/originalHref';
import { setAlert } from '../../../../../redux/alerts/action';
import CustomButton from '../../../../layout/customButton/CustomButton';
import { ReactComponent as AuditTrailIcon } from '../../../../../assets/icons/AuditTrailIcon.svg';

const DocumentItem = ({
	client,
	latestStatus,
	closeModal,
	agreementById,
	openModal,
	getAuditTrail,
	handleDeleteDocument,
	setDocumentTarget,
	userType,
	setAlert,
	setLoading,
	clientInfo,
}) => {
	console.log(
		`DocumentItem client ${latestStatus?.documentName}`,
		client,
		latestStatus
	);

	const [isSecondPurchaser, setIsSecondPurchaser] = useState(false);

	useEffect(() => {
		if (
			clientInfo?.individual &&
			Object.keys(clientInfo?.individual).length > 1
		) {
			setIsSecondPurchaser(true);
		} else {
			setIsSecondPurchaser(false);
		}
	}, [clientInfo]);

	const history = useHistory();
	//---- Doc sent to home buyer
	//---- Admin to review
	//---- Builder to sign
	//---- Cooling period
	//---- Firm deal

	const styleClientStatus = () => {
		console.log(
			'latestStatuslatestStatus',
			latestStatus.status,
			client.leadId
		);
		if (latestStatus?.documentName === 'APS') {
			console.log('styleClientStatus aps');
			if (isSecondPurchaser === false) {
				if (
					latestStatus?.status === 'client_signed' ||
					latestStatus?.status === 'builder_signed' ||
					latestStatus?.status === 'admin_signed'
				) {
					return { color: 'var(--success)' };
				} else if (latestStatus?.status === 'not_sent') {
					return { color: '' };
				} else {
					return { color: 'var(--warning)' };
				}
			} else if (isSecondPurchaser === true) {
				if (
					latestStatus?.status === 'second_client_signed' ||
					latestStatus?.status === 'builder_signed' ||
					latestStatus?.status === 'admin_signed'
				) {
					return { color: 'var(--success)' };
				} else if (latestStatus?.status === 'not_sent') {
					return { color: '' };
				} else {
					return { color: 'var(--warning)' };
				}
			}
		} else if (latestStatus?.documentName === 'Condo Docs') {
			console.log(
				'latestStatus?.statuslatestStatus?.status',
				latestStatus
			);
			if (
				latestStatus?.status === 'client_signed' ||
				latestStatus?.status === 'builder_signed' ||
				latestStatus?.status === 'admin_signed'
			) {
				return { color: 'var(--success)' };
			} else {
				return { color: 'var(--warning)' };
			}
		} else {
			return { color: 'none' };
		}
	};

	const styleAdminStatus = () => {
		if (latestStatus?.documentName === 'APS') {
			if (isSecondPurchaser === false) {
				if (
					latestStatus?.status === 'admin_signed' ||
					latestStatus?.status === 'builder_signed'
				) {
					return { color: 'var(--success)' };
				} else if (latestStatus?.status === 'client_signed') {
					return { color: 'var(--warning)' };
				} else {
					return { color: 'none' };
				}
			} else if (isSecondPurchaser === true) {
				if (
					latestStatus?.status === 'admin_signed' ||
					latestStatus?.status === 'builder_signed'
				) {
					return { color: 'var(--success)' };
				} else if (latestStatus?.status === 'second_client_signed') {
					return { color: 'var(--warning)' };
				} else {
					return { color: 'none' };
				}
			}
		} else if (latestStatus?.documentName === 'Condo Docs') {
			if (
				latestStatus?.status === 'admin_signed' ||
				latestStatus?.status === 'builder_signed'
			) {
				return { color: 'var(--success)' };
			} else if (latestStatus?.status === 'client_signed') {
				return { color: 'var(--warning)' };
			} else {
				return { color: 'none' };
			}
		} else {
			return { color: 'none' };
		}
	};

	const styleBuilderStatus = () => {
		if (latestStatus?.documentName === 'APS') {
			if (isSecondPurchaser === false) {
				if (latestStatus?.status === 'builder_signed') {
					console.log('styleClientStatus here 1');
					return { color: 'var(--success)' };
				} else if (latestStatus?.status === 'admin_signed') {
					return { color: 'var(--warning)' };
				} else {
					return { color: 'none' };
				}
			} else if (isSecondPurchaser === true) {
				if (latestStatus?.status === 'builder_signed') {
					console.log('styleClientStatus here 1');
					return { color: 'var(--success)' };
				} else if (latestStatus?.status === 'admin_signed') {
					return { color: 'var(--warning)' };
				} else {
					return { color: 'none' };
				}
			}
		} else if (latestStatus?.documentName === 'Condo Docs') {
			if (latestStatus?.status === 'builder_signed') {
				console.log('styleClientStatus here 1');
				return { color: 'var(--success)' };
			} else if (latestStatus?.status === 'client_signed') {
				return { color: 'var(--warning)' };
			} else {
				return { color: 'none' };
			}
		}
	};

	const handleContinueAgreement = (clientId) => {
		history.push({
			pathname: `/agreement/${client.leadId}`,
			state: {
				from: 'Purchasers',
			},
		});
	};

	const handleViewDocument = () => {
		console.log('handleViewDocument client', client);
		setLoading(true);
		if (
			agreementById?.documentInformation?.documentStatus === 'sent' &&
			latestStatus?.eventType !== 'signature_request_canceled'
		) {
			viewDocument(
				agreementById,
				client.leadId,
				latestStatus.documentName,
				(returned) => {
					setAlert('warning', returned);
				},
				(returned) => {
					setLoading(returned);
				}
			);
		} else {
			handleContinueAgreement(client.leadId);
		}
		closeModal('clientDetails');
	};

	const handleAuditTrail = () => {
		openModal('auditTrail');

		var doc;

		if (latestStatus.documentName === 'APS') {
			doc = DOCUMENT_NAME.aps;
		} else if (latestStatus.documentName === 'Condo Docs') {
			doc = DOCUMENT_NAME.condo_docs;
		} else {
			doc = latestStatus.documentName;
		}

		console.log('handleAuditTrail ', latestStatus, doc);
		getAuditTrail(client.leadId, doc);
	};
	const openDealReview = () => {
		openModal('reviewAps');
	};
	return (
		<>
			{latestStatus !== undefined && client?.leadId !== undefined && (
				<TableRow
					className={
						latestStatus?.eventType ===
							'signature_request_canceled' && styles.disabled
					}
				>
					<TableCell className={styles.cellItem} width={130}>
						<div className={styles.documentName}>
							{latestStatus?.documentName === 'APS' &&
							latestStatus?.timestamp ? (
								<Tooltip title={'APS Review'}>
									<span
										style={{ cursor: 'pointer' }}
										onClick={openDealReview}
									>
										{latestStatus?.documentName}
									</span>
								</Tooltip>
							) : (
								<span>{latestStatus?.documentName}</span>
							)}
						</div>
					</TableCell>
					{console.log('latestStatus?.eventType', latestStatus)}
					<TableCell
						width={150}
						className={styles.cellItem}
						align='left'
						style={{
							paddingLeft: '10px',
						}}
					>
						{latestStatus?.timestamp ? (
							<>
								{dayjs(latestStatus?.timestamp).format(
									'MMMM DD, YYYY'
								)}
							</>
						) : (
							<div
								style={{
									paddingLeft: '30px',
								}}
							>
								---
							</div>
						)}
					</TableCell>
					<TableCell width={200} className={styles.cellItem}>
						{latestStatus?.documentName === 'APS' ||
						latestStatus?.documentName === 'Condo Docs' ? (
							<div className={styles.statusGroup}>
								<div className={styles.statusItem}>
									<CheckCircleIcon
										style={{ ...styleClientStatus(client) }}
									/>
									Client
								</div>
								<div className={styles.statusItem}>
									<CheckCircleIcon
										style={{ ...styleAdminStatus() }}
									/>{' '}
									Admin
								</div>
								<div className={styles.statusItem}>
									<CheckCircleIcon
										style={{ ...styleBuilderStatus() }}
									/>{' '}
									Builder
								</div>
							</div>
						) : (
							<div className={styles.statusGroup}>
								{latestStatus?.extras?.length > 0 ? (
									<>
										{latestStatus?.extras?.map((signer) => {
											if (signer.signerRole !== 'Admin') {
												return (
													<div
														className={
															styles.statusItem
														}
													>
														<CheckCircleIcon
															style={{
																color: `${signer.color}`,
															}}
														/>
														{signer.signerRole}
													</div>
												);
											}
										})}
									</>
								) : (
									<div className={styles.statusItem}>
										<CheckCircleIcon
										// style={{ ...styleClientStatus(client) }}
										/>
										Client
									</div>
								)}
							</div>
						)}
					</TableCell>
					<TableCell width={200} className={styles.cellItem}>
						<div className={styles.filesGroup}>
							{/* Document */}
							{/* <InsertDriveFileIcon
								onClick={() => {
									handleViewDocument();
								}}
								key={client.leadId}
							/> */}

							<div
								className={`${styles.fileItem} ${
									latestStatus?.timestamp && styles.outline
								}`}
								onClick={() => {
									handleViewDocument();
								}}
								key={client.leadId}
							>
								{latestStatus?.timestamp
									? 'View document'
									: 'Continue document'}
							</div>

							<div
								// className={styles.fileItem}
								onClick={() => {
									handleAuditTrail();
								}}
							>
								<AuditTrailIcon />
							</div>
						</div>
					</TableCell>
					<TableCell width={10} className={styles.cellItem}>
						<div
							onClick={() => {
								handleDeleteDocument(latestStatus);
								setDocumentTarget(latestStatus);
							}}
							className={`${
								(latestStatus?.status === 'builder_signed' &&
									userType === 'admin') ||
								(latestStatus?.status === 'not_sent' &&
									styles.disabledIcon)
							}`}
						>
							<DeleteIcon className={styles.deleteIcon} />
						</div>
					</TableCell>
				</TableRow>
			)}
		</>
	);
};

const mapStateToProps = (state) => ({
	userType: state.signIn.userType,
	clientInfo: state.agreement.agreementById?.clientInfo,
});
export default connect(mapStateToProps, {
	openModal,
	closeModal,
	getAuditTrail,
	setDocumentTarget,
	setAlert,
	setLoading,
})(DocumentItem);
